import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = {
  key: 0,
  class: "mt-2 mb-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "input__label" }, "Czy koła posiadają czujniki ciśnienia?", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "identities-form__storage-info" }, "Od 11.2014 nowe samochody sprzedawane w UE muszą mieć czujniki ciśnienia w oponach.", -1)
const _hoisted_5 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "input__label" }, "Czy opony są typu Run Flat?", -1)
const _hoisted_7 = {
  key: 2,
  class: "mb-5"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "input__label" }, "Czy chcesz zostawić koła/opony w przechowalni?", -1)
const _hoisted_9 = {
  key: 0,
  class: "identities-form__storage-info"
}
const _hoisted_10 = {
  key: 1,
  class: "identities-form__storage-info"
}
const _hoisted_11 = {
  key: 3,
  class: "mb-5"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "input__label" }, "Chcesz umówić się dodatkowo na coroczną wymianę oleju silnikowego?", -1)
const _hoisted_13 = {
  key: 0,
  class: "identities-form__storage-info"
}
const _hoisted_14 = {
  key: 1,
  class: "identities-form__storage-info"
}
const _hoisted_15 = {
  key: 2,
  class: "identities-form__storage-info"
}
const _hoisted_16 = {
  key: 4,
  class: "mb-5"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "input__label" }, "Czy chcesz dodatkowo zlecić wykonanie serwisu klimatyzacji? Zaleca się serwisowanie co roku, by zapewnić czystość i poprawne działanie układu.", -1)
const _hoisted_18 = {
  key: 0,
  class: "identities-form__storage-info"
}
const _hoisted_19 = {
  key: 1,
  class: "identities-form__storage-info"
}
const _hoisted_20 = {
  key: 2,
  class: "identities-form__storage-info"
}
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "terms-paragraph mt-5" }, [
  /*#__PURE__*/_createTextVNode(" Rezerwacja oznacza akceptację "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://dobrymechanik.pl/pomoc/regulamin/",
    target: "_blank"
  }, " regulaminu "),
  /*#__PURE__*/_createTextVNode(" oraz polityki "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://dobrymechanik.pl/pomoc/polityka_prywatnosci/",
    target: "_blank"
  }, " prywatności ")
], -1)
const _hoisted_24 = { class: "identities-form-marketing__submit-button-wrapper" }

import { DmButton, DmPhone, DmCheckbox, DmInput } from '@dobrymechanik/vue-ui-v2';
import { useFormCreator } from '../composables/useFormCreator';
import { computed, ref, ComputedRef } from 'vue';
import { IDmComponentsItem } from '@/components/UIComponents/DmRadioButton.vue';
import DmRadioButton from '@/components/UIComponents/DmRadioButton.vue';


interface IIdentitiesFormFields {
  name: string;
  phone: string;
  email: string;
  licensePlate: string;
  vin: string;
  marketing: boolean;
  tyrePressureSensor: IDmComponentsItem | null;
  tyreRunFlat: IDmComponentsItem | null;
  tyreStorage: IDmComponentsItem | null;
  oilChange: IDmComponentsItem | null;
  conditioningService: IDmComponentsItem | null;
}

interface IIdentitiesFormProps {
  dataMechanicId: string;
  dataFlow: string;
  dataSource: string;
  dataShowVin: boolean;
  dataTokenKey: string;
  dataTokenFields: string;
  dataUpsell: string;
}

interface IUpsell {
  tyreStorage: number;
  tyreStoragePriceFrom: number;
  tyreStoragePriceTo: number;
  tyreRunFlat: number;
  tyrePressureSensor: number;
  oilChange: number;
  oilChangePriceFrom: number;
  oilChangePriceTo: number;
  airConditioningService: number;
  airConditioningServicePriceFrom: number;
  airConditioningServicePriceTo: number;
}

interface SubmitEvent extends Event {
  submitter: HTMLElement;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    dataMechanicId: { type: String, required: true },
    dataFlow: { type: String, required: true },
    dataSource: { type: String, required: true },
    dataShowVin: { type: Boolean, required: true },
    dataTokenKey: { type: String, required: true },
    dataTokenFields: { type: String, required: true },
    dataUpsell: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as {
  dataMechanicId: string;
  dataFlow: string;
  dataSource: string;
  dataShowVin: boolean;
  dataTokenKey: string;
  dataTokenFields: string;
  dataUpsell: string;
}

const radioOptions = [
  { key: 'T', text: 'Tak' },
  { key: 'N', text: 'Nie' },
  { key: 'NW', text: 'Nie wiem' },
];

// REFS
const identitiesForm = ref();

// USE
const { form, valid, updateErrors } = useFormCreator<IIdentitiesFormFields>({
  name: '',
  phone: '',
  email: '',
  licensePlate: '',
  vin: '',
  marketing: false,
  tyrePressureSensor: null,
  tyreRunFlat: null,
  tyreStorage: null,
  oilChange: null,
  conditioningService: null
});

// METHODS
const submitForm = (e: SubmitEvent): void => {
  const form = identitiesForm.value as HTMLFormElement;

  form.checkValidity();
  const firstEl = (form.querySelector(':invalid') as HTMLElement) || (form.getElementsByClassName('input--error')[0] as HTMLElement);

  if (firstEl) {
    window.scrollTo({
      top: document.documentElement.scrollTop + firstEl.getBoundingClientRect().top - 40,
      left: 0,
      behavior: "smooth",
    });

    firstEl.focus();
  }

  setTimeout(() => {
    if (!valid.value) return;
    identitiesForm.value.submit();
  }, 0);
};

// COMPUTED
const upsell: ComputedRef<IUpsell> = computed(() => {
  return JSON.parse(props.dataUpsell);
});


const isAbleToSubmit = computed(() => {
  return !(upsell.value.tyreStorage && !form.fields.tyreStorage)
    && !(upsell.value.tyreRunFlat && !form.fields.tyreRunFlat)
    && !(upsell.value.tyrePressureSensor && !form.fields.tyrePressureSensor)
    && !(upsell.value.oilChange && !form.fields.oilChange)
    && form.fields.name
    && form.fields.phone
    && form.fields.email
    && form.fields.licensePlate
    && valid.value;
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    ref: (_value, _refs) => {
      _refs['identitiesForm'] = _value
      identitiesForm.value = _value
    },
    method: "POST",
    action: `/calendars/create/${__props.dataMechanicId}?wersja=kroki&krok=2?wersja=kroki&krok=2&flow=${__props.dataFlow}&source=${__props.dataSource}&account=${_unref(form).fields.marketing}`,
    onSubmit: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", null, [
      (_unref(upsell).tyrePressureSensor)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(DmRadioButton, {
              items: radioOptions,
              modelValue: _unref(form).fields.tyrePressureSensor,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).fields.tyrePressureSensor) = $event)),
              name: "data[CalendarEvent][tyrePressureSensor]",
              "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => (_unref(updateErrors)($event, 'tyrePressureSensor')))
            }, null, 8, ["modelValue"]),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (_unref(upsell).tyreRunFlat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(DmRadioButton, {
              items: radioOptions,
              modelValue: _unref(form).fields.tyreRunFlat,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).fields.tyreRunFlat) = $event)),
              name: "data[CalendarEvent][tyreRunFlat]",
              "onUpdate:errors": _cache[3] || (_cache[3] = ($event: any) => (_unref(updateErrors)($event, 'tyreRunFlat')))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_unref(upsell).tyreStorage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(DmRadioButton, {
              items: radioOptions,
              modelValue: _unref(form).fields.tyreStorage,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).fields.tyreStorage) = $event)),
              name: "data[CalendarEvent][tyreStorage]",
              "onUpdate:errors": _cache[5] || (_cache[5] = ($event: any) => (_unref(updateErrors)($event, 'tyreStorage')))
            }, null, 8, ["modelValue"]),
            (_unref(upsell).tyreStoragePriceTo && _unref(upsell).tyreStoragePriceFrom)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Koszt przechowania opon wynosi od " + _toDisplayString(_unref(upsell).tyreStoragePriceFrom) + " do " + _toDisplayString(_unref(upsell).tyreStoragePriceTo) + " zł", 1))
              : (_unref(upsell).tyreStoragePriceFrom)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Koszt przechowania opon wynosi od " + _toDisplayString(_unref(upsell).tyreStoragePriceFrom) + " zł", 1))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(upsell).oilChange)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(DmRadioButton, {
              items: radioOptions,
              modelValue: _unref(form).fields.oilChange,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).fields.oilChange) = $event)),
              name: "data[CalendarEvent][oilChange]",
              "onUpdate:errors": _cache[7] || (_cache[7] = ($event: any) => (_unref(updateErrors)($event, 'oilChange')))
            }, null, 8, ["modelValue"]),
            (_unref(upsell).oilChangePriceFrom && _unref(upsell).oilChangePriceTo)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Uwaga: usługa może wiązać się z koniecznością zostawienia auta w warsztacie. Przewidywany koszt: od " + _toDisplayString(_unref(upsell).oilChangePriceFrom) + " do " + _toDisplayString(_unref(upsell).oilChangePriceTo) + " zł ", 1))
              : (_unref(upsell).oilChangePriceFrom)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Uwaga: usługa może wiązać się z koniecznością zostawienia auta w warsztacie. Przewidywany koszt: od " + _toDisplayString(_unref(upsell).oilChangePriceFrom) + " zł ", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_15, " Uwaga: usługa może wiązać się z koniecznością zostawienia auta w warsztacie. "))
          ]))
        : _createCommentVNode("", true),
      (_unref(upsell).airConditioningService)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(DmRadioButton, {
              items: radioOptions,
              modelValue: _unref(form).fields.conditioningService,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).fields.conditioningService) = $event)),
              name: "data[CalendarEvent][airConditioningService]",
              "onUpdate:errors": _cache[9] || (_cache[9] = ($event: any) => (_unref(updateErrors)($event, 'airConditioningService')))
            }, null, 8, ["modelValue"]),
            (_unref(upsell).airConditioningServicePriceFrom && _unref(upsell).airConditioningServicePriceTo)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Uwaga: usługa może wiązać się z koniecznością zostawienia auta w warsztacie. Przewidywany koszt: od " + _toDisplayString(_unref(upsell).airConditioningServicePriceFrom) + " do " + _toDisplayString(_unref(upsell).airConditioningServicePriceTo) + " zł ", 1))
              : (_unref(upsell).airConditioningServicePriceFrom)
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Uwaga: usługa może wiązać się z koniecznością zostawienia auta w warsztacie. Przewidywany koszt: od " + _toDisplayString(_unref(upsell).airConditioningServicePriceFrom) + " zł ", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_20, " Uwaga: usługa może wiązać się z koniecznością zostawienia auta w warsztacie. "))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(DmInput), {
      id: "identities-form-name",
      modelValue: _unref(form).fields.name,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).fields.name) = $event)),
      label: "Imię i nazwisko",
      name: "data[CalendarEvent][name]",
      pattern: ".{2}",
      error: "Wpisz poprawne imię i nazwisko",
      required: "",
      placeholder: "Imię i nazwisko",
      "onUpdate:errors": _cache[11] || (_cache[11] = ($event: any) => (_unref(updateErrors)($event, 'name')))
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(DmPhone), {
      id: "identities-form-phone",
      modelValue: _unref(form).fields.phone,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).fields.phone) = $event)),
      placeholder: "Numer telefonu",
      error: "Wpisz poprawny numer telefonu",
      label: "Numer telefonu",
      required: "",
      "onUpdate:errors": _cache[13] || (_cache[13] = ($event: any) => (_unref(updateErrors)($event, 'phone-number')))
    }, null, 8, ["modelValue"]),
    _createElementVNode("input", {
      name: "data[CalendarEvent][phone]",
      value: _unref(form).fields.phone,
      type: "hidden"
    }, null, 8, _hoisted_21),
    _createElementVNode("input", {
      name: "data[CalendarEvent][account]",
      value: _unref(form).fields.marketing,
      type: "hidden"
    }, null, 8, _hoisted_22),
    _createVNode(_unref(DmInput), {
      id: "identities-form-email",
      modelValue: _unref(form).fields.email,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).fields.email) = $event)),
      type: "email",
      label: "Adres e-mail",
      name: "data[CalendarEvent][email]",
      pattern: "^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$",
      error: "Wpisz poprawny adres e-mail",
      required: "",
      placeholder: "Adres e-mail",
      "onUpdate:errors": _cache[15] || (_cache[15] = ($event: any) => (_unref(updateErrors)($event, 'email')))
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(DmInput), {
      id: "identities-form-license_plate",
      modelValue: _unref(form).fields.licensePlate,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(form).fields.licensePlate) = $event)),
      label: "Numer rejestracyjny",
      name: "data[CalendarEvent][license_plate]",
      pattern: "(^[A-z0-9]{4,8}$)|(^[A-z0-9](\\s?[A-z0-9]){3,7}$)",
      error: "Wpisz poprawny numer rejestracyjny",
      required: "",
      placeholder: "Numer rejestracyjny",
      "onUpdate:errors": _cache[17] || (_cache[17] = ($event: any) => (_unref(updateErrors)($event, 'licensePlate')))
    }, null, 8, ["modelValue"]),
    (!!__props.dataShowVin)
      ? (_openBlock(), _createBlock(_unref(DmInput), {
          key: 0,
          id: "identities-form-vin",
          modelValue: _unref(form).fields.vin,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(form).fields.vin) = $event)),
          label: "VIN (znajdziesz go w dowodzie)",
          name: "data[CalendarEvent][car_vin]",
          pattern: "^.{12,17}$",
          error: "Wpisz poprawny numer VIN",
          placeholder: "VIN",
          "onUpdate:errors": _cache[19] || (_cache[19] = ($event: any) => (_unref(updateErrors)($event, 'vin')))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _hoisted_23,
    _createVNode(_unref(DmCheckbox), {
      id: "identities-form-marketing",
      modelValue: _unref(form).fields.marketing,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(form).fields.marketing) = $event)),
      class: "identities-form-marketing__checkbox",
      name: "data[CalendarEvent][marketing]",
      label: "Chcę otrzymywać praktyczne informacje marketingowe drogą mailową od Dobry Mechanik! Wiem, że mogę w każdej chwili cofnąć moją zgodę.",
      "onUpdate:errors": _cache[21] || (_cache[21] = ($event: any) => (_unref(updateErrors)($event, 'marketing')))
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_unref(DmButton), {
        id: "identities-form-submitter",
        title: "Umów wizytę",
        onClick: submitForm
      })
    ])
  ], 40, _hoisted_1))
}
}

})